module.exports = __webpack_public_path__ + "img/no-msg.08642e41.png";